<template>
  <div>
    <div v-if="this.$router.currentRoute.name === 'board' || this.$router.currentRoute.name === 'animer'">
      <div
        @click="popupToggle"
        class="button is-big is-primary is-pulled-right addpost"
      ><span style="    margin-top: -8px;">+</span></div>
    </div>

    <div v-bind:class="{modal: true, 'is-active': editing }">
      <div
        @click="popupToggle"
        class="modal-background"
      ></div>
      <div class="modal-content">
        <div class="box">
          <div
            class="field"
            id="mainBody"
          >
            <label class="label"></label>
            <div class="control">
              <colorPicker></colorPicker>
              <b-input
                ref="
              postContenu"
                v-model="post.contenu"
                name="Post_it"
                @input="log"
                maxlength="400"
                rows="3"
                :placeholder="''"
                type="textarea"
              >
              </b-input>
              <b-field
                :type="{ 'is-danger': isDisabled }"
                :message="{ 'URL invalide' : isDisabled }"
                v-bind:class="{'is-hidden':!post.contenu}"
              >
                <b-input
                  icon-pack="fas"
                  icon="link"
                  type="text"
                  v-model="post.link"
                  :placeholder="$t('post.link.placeholder')"
                  maxlength="255"
                ></b-input>
              </b-field>

              <div v-if="post.contenu">
                <b-upload
                  accept="image/png,image/gif,image/jpeg,video/mp4"
                  v-model="file"
                  :input="checkFileSize()"
                >
                  <span
                    class="clickable"
                    v-if="!file"
                  >
                    <img
                      id="addPhoto"
                      src="/static/add_photo.png"
                      alt="picture icon"
                    />
                    {{$t('post.illustrer_question')}}
                  </span>
                </b-upload>
                <div v-if="file">
                  <b-icon
                    pack="fas"
                    icon="check-square"
                    size="is-small"
                  ></b-icon> {{$t('post.illustrer_ok')}}
                  <b-image
                    :src="fileToUrl"
                    alt=""
                    style="max-height:100px; max-width:100px; margin: 5px auto;"
                  ></b-image>
                  <span
                    class="is-pulled-right"
                    style="cursor:pointer;"
                    @click="removeFile"
                  >
                    <b-icon
                      pack="fas"
                      icon="trash-alt"
                      size="is-small"
                    ></b-icon>
                  </span>
                </div>
              </div><br>

              <template v-if="(this.$store.state.board.newPostit.id !== null)">
                <br>
                <b-select
                  v-model="post.sheet_id"
                  placeholder="Feuille"
                  icon="book-open"
                  icon-pack="fas"
                  id="selectsheet"
                  v-bind:class="{'is-hidden':!post.contenu}"
                  @input="post.folder_id = 'null'"
                >

                  <template v-for="(sheet, i) in current.sheets">
                    <option
                      v-if="sheet.id === post.sheet_id"
                      :key="i"
                      :value="sheet.id"
                      selected
                    >{{ sheet.name }}</option>
                    <option
                      v-else
                      :key="i"
                      :value="sheet.id"
                    >{{ sheet.name }}</option>
                  </template>

                </b-select>

              </template>
            </div>
          </div>
          <div class="clearfix"></div>
          <div
            class="field"
            id="optionsButtons"
          > <button
              @click="popupToggle"
              class="button"
            >{{ $t('button.annuler') }}</button>
            <button
              v-if="loading"
              class="button is-primary"
            >{{ $t('tooltip.loading') }}</button>
            <button
              v-else
              @click=" createPostButton"
              :disabled="isDisabled "
              class="button is-primary"
            >{{ $t('button.poster') }}</button>

          </div>
          <!-- <div
            id="bottomContainer"
            v-if="this.newPostit.id"
          >
            <div
              class="button is-danger"
              @click="confirmDelete"
            > {{$t('delete')}}</div>
          </div> -->
        </div>
      </div>
      <button
        @click="popupToggle"
        class="modal-close is-large"
        aria-label="close"
      ></button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import colorPicker from './toolbar/colorPicker'
const { mapState } = createNamespacedHelpers('board')
export default {
  name: 'addPostButton',
  components: {
    colorPicker: colorPicker
  },
  data () {
    return {
      loading: false,
      file: null,
      isActive: false,
      post: {
        media: '',
        contenu: '',
        couleur: '',
        link: '',
        sheet_id: null
      }
    }
  },
  props: {
    editing: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    fileToUrl () {
      return URL.createObjectURL(this.file)
    },
    postLength () {
      this.log(this.post.contenu.replace(/\n/g, ` `))
      return this.post.contenu.replace(/\n/g, ` `).length
    },
    ...mapState({
      newPostit: 'newPostit',
      currentSheet: 'currentSheet',
      current: 'current'
    }),
    isDisabled () {
      if (this.post.link && !this.verifUrl(this.post.link)) { return true } else { return false }
    }
  },

  watch: {
    editing: {
      handler (editing) {
        this.editing = editing
      },
      deep: true,
      immediate: true
    },
    newPostit: {
      handler (newPostit) {
        this.post.contenu = newPostit.contenu
        this.post.sheet_id = newPostit.sheet_id
        this.post.link = newPostit.link
        this.post.folder_id = newPostit.folder_id
        this.post.links = newPostit.links
        this.post.coord_x = newPostit.coord_x
        this.post.coord_y = newPostit.coord_y
        this.post.media = newPostit.media
        if (newPostit.media) {
          fetch(process.env.URL_MEDIA + 'uploads/brainstorming/medias/' + newPostit.media).then(this.setFile) // si un media est lié au postit, on le fetch coté backend
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async setFile (res) {
      let body = await res.blob()
      console.log(body);

      let file = new File([body], this.newPostit.media)
      this.file = file
    },
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    log (e) {
      console.log(e)
    },
    confirmDelete () {
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t('dialog.cancel'),
        confirmText: this.$i18n.t('button.supprimer'),
        message: this.$i18n.t('post.supprimer.message'),
        onConfirm: () => { this.deletepost() }
      })
    },
    deletepost () {
      this.newPostit.etat = 'poubelle'
      this.$store.dispatch('board/updatePostData', {
        board: this.$store.state.board.current,
        post: this.newPostit
      })
      this.$buefy.toast.open({
        message: this.$i18n.t('post.supprimer.notification'),
        type: 'is-success',
        position: 'is-bottom'
      })
      this.$store.commit('board/NEW_POST_POPUP_STATE', false)
    },
    checkFileSize () {
      if (this.file && this.file.size > 600000) {
        this.file = null
        this.$buefy.toast.open({
          type: 'is-danger',
          message: this.$i18n.t('toast.fichier_trop_lourd')
        })
      }
    },
    removeFile () {
      this.file = null
    },
    popupToggle: function (event) {
      this.file = null
      if (this.editing) {
        this.post.contenu = ''
      } else {
        this.sendMessageToParent('scrollToTop')
        var w = window
        var d = document
        var e = d.documentElement
        var g = d.getElementsByTagName('body')[0]
        var x = w.innerWidth || e.clientWidth || g.clientWidth
        var y = w.innerHeight || e.clientHeight || g.clientHeight

        x = x / 2
        y = y / 2

        this.$store.commit('board/NEW_POST_DEFINE_COORDS', {
          coord_x: (x + Math.abs(document.getElementById('svgBoard').getBoundingClientRect().left)),
          coord_y: (y + Math.abs(document.getElementById('svgBoard').getBoundingClientRect().top))
        })
      }
      this.$store.commit('board/NEW_POST_POPUP_STATE', !this.editing)
    },
    createPostButton: async function () {
      this.loading = true
      var str = ''
      if (this.post.contenu === '') { // check post pas vide
        this.loading = false
        this.$buefy.toast.open({
          message: this.$i18n.t('post.creation.empty'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      } else if (this.post.contenu.length > 400) { // post pas trop long
        this.loading = false
        this.$buefy.toast.open({
          message: this.$i18n.t('post.creation.toolong'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      } else {
        if ((this.$store.state.board.newPostit.id === null) || (this.$store.state.board.newPostit.id === undefined)) { // Si nouveau post
          this.post.coord_x = this.$store.state.board.newPostit.coord_x
          this.post.coord_y = this.$store.state.board.newPostit.coord_y
          this.post.couleur = this.$store.state.board.currentSelectedColor
          this.post.sheet_id = this.currentSheet
          this.post.media = this.file
          if (this.$store.state.board.current.mode === 'libre') {
            this.post.etat = 'publie'
          }
          if (this.$store.state.board.current.mode === 'moderee') {
            this.post.etat = 'attente'
          }
          this.$store.dispatch('board/newPost', { post: this.post, board: this.$store.state.board.current })
            .then(res => {
              this.loading = false
              // console.log(res)
              if (res.status >= 200 && res.status <= 399) {
                this.popupToggle()
                str = this.$store.state.board.current.mode === 'moderee' ? this.$i18n.t('post.creation.message') + this.$i18n.t('post.creation.message.moderee') : this.$i18n.t('post.creation.message')

                this.$buefy.toast.open({
                  message: str,
                  type: 'is-success',
                  position: 'is-bottom'
                })
              } else {
                str = this.$i18n.t('toast.network_error')

                this.$buefy.toast.open({
                  message: str,
                  type: 'is-danger',
                  position: 'is-bottom'
                })
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch(err => {
              this.loading = false
              str = this.$i18n.t('toast.network_error')

              this.$buefy.toast.open({
                message: str,
                type: 'is-danger',
                position: 'is-bottom'
              })
            })
        } else { // Si edition de postits
          this.post.id = this.$store.state.board.newPostit.id
          this.post.couleur = this.$store.state.board.currentSelectedColor
          this.post.media = this.file
          // this.$store.dispatch('board/updatePostData', { board: this.$store.state.board.current, post: this.post })
          this.$store.dispatch('board/updatePostData', { board: this.$store.state.board.current, post: this.post })
            .then(res => {
              if (res.status >= 200 && res.status <= 399) {
                this.loading = false
                this.popupToggle()
                str = this.$i18n.t('post.modification.message')

                this.$buefy.toast.open({
                  message: str,
                  type: 'is-success',
                  position: 'is-bottom'
                })
              } else {
                this.loading = false
                str = this.$i18n.t('toast.network_error')

                this.$buefy.toast.open({
                  message: str,
                  type: 'is-danger',
                  position: 'is-bottom'
                })
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch(err => {
              this.loading = false
              str = this.$i18n.t('toast.network_error')

              this.$buefy.toast.open({
                message: str,
                type: 'is-success',
                position: 'is-bottom'
              })
            })
        }
      }
    },
    verifUrl (url) {
      var myRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
      if (myRegex.test(url)) {
        return true
      } else {
        return false
      }
    }
  }

}

</script>
<style scoped>
.control {
  text-align: left !important;
}

#bottomContainer {
  order: 4;
  right: 20px;
  width: min-content;
  position: relative;
  margin-left: calc(100% - 90px);
}
#mainBody {
  order: 3;
}
.box {
  display: flex;
  flex-flow: column;
}
.red {
  color: red;
}
.addpost {
  position: fixed;
  top: 0;
  right: 0;
  margin: 150px 50px 0 0;
  border-radius: 100%;
  width: 60px;
  height: 60px;
  font-size: 40px;
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.3);
  z-index: 8;
  padding: 0px;
}
@media only screen and (max-width: 740px) {
  .addpost {
    margin: 150px 20px 0 0;
  }
}
@media only screen and (max-width: 480px) {
  .addpost {
    margin: 180px 20px 0 0;
  }
}

@media only screen and (max-width: 300px) {
  .addpost {
    margin: 200px 20px 0 0;
  }
}

textarea {
  width: 100%;
  height: 150px;
  white-space: pre-wrap !important;
}
#selectsheet {
  width: 100%;
}
.select {
  width: 100% !important;
}
#optionsButtons {
  order: 3;
}
.clickable {
  cursor: pointer;
}
#addPhoto {
  height: 15px;
  width: auto;
  margin: 5px auto -3px;
}

/* @media screen and (max-height: 900px) {
  .box {
    display: flex;
  }
  #optionsButtons {
    order: 1;
    margin-bottom: 20px;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/board/addPostButton.vue